import {
   Component,
   Input,
   OnInit,
   ChangeDetectionStrategy
} from '@angular/core';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-company-info',
    templateUrl: './company-info.component.html',
    styleUrls: ['./company-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CompanyInfoComponent implements OnInit {
   @Input() stockName!: string;
   @Input() stockDescription!: string;
   @Input() stockLogo!: string;
   @Input() hideLogo?: boolean = false;
   @Input() stockTicker!: string;
   @Input() type!: string;

   @Input() fullCountryName?: string;
   @Input() lastUpdate?: number;
   @Input() stock?: any;
   @Input() reportTypeSection?: string;
   @Input() reportTypeYear?: string;

   /** PRECOMPUTED (template-safe) */
   lastUpdatedMeta = '';
   quarterText = '';

   isExpanded = false;

   constructor(private datePipe: DatePipe) { }

   ngOnInit(): void {
      this.computeLastUpdated();
      this.computeQuarterText();
   }

   private computeLastUpdated(): void {
      if (!this.lastUpdate) return;

      const timestamp = this.lastUpdate * 1000;
      this.lastUpdatedMeta = new Date(timestamp).toISOString();
   }

   private computeQuarterText(): void {
      if (!this.reportTypeSection || !this.reportTypeYear) {
         this.quarterText = '';
         return;
      }

      if (['Annual', 'ANNUAL'].includes(this.reportTypeSection)) {
         this.quarterText = `${this.reportTypeYear} Annual`;
         return;
      }

      const quarterMap: Record<string, string> = {
         firstQuarter: 'Q1',
         FIRST_QUARTER: 'Q1',
         secondQuarter: 'Q2',
         SECOND_QUARTER: 'Q2',
         thirdQuarter: 'Q3',
         THIRD_QUARTER: 'Q3',
         fourthQuarter: 'Q4',
         FOURTH_QUARTER: 'Q4'
      };

      const quarter = quarterMap[this.reportTypeSection] || '';
      this.quarterText = `${quarter}, ${this.reportTypeYear}`;
   }
}
